import client from './client';

/**
 * Findings API
 *
 * Retrieves integrity findings for a session.
 */

/**
 * Get all findings for a session (requires HOST auth).
 * @param {string|number} sessionId
 */
export const getFindings = (sessionId) => {
  console.log('[findings] getFindings', sessionId);
  return client.get(`/api/sessions/${sessionId}/findings`);
};
